import { ProcessingEventProgress } from '@nextforce/api'
import React, { createContext, useContext, useState } from 'react'

interface MemberListProgressContextValue {
  progress: ProcessingEventProgress
  setProgress: React.Dispatch<React.SetStateAction<ProcessingEventProgress>>
}

interface Props {
  children: React.ReactNode
}

const MemberListProgressContext = createContext(
  {} as MemberListProgressContextValue
)

export function MemberListProgressProvider(props: Props) {
  const [progress, setProgress] = useState<ProcessingEventProgress>({
    current: 0,
    total: 0,
  })

  const value: MemberListProgressContextValue = {
    progress,
    setProgress,
  }
  return (
    <MemberListProgressContext.Provider value={value}>
      {props.children}
    </MemberListProgressContext.Provider>
  )
}

export function useMemberListProgressContext() {
  return useContext<MemberListProgressContextValue>(MemberListProgressContext)
}
